<template>
  <span>
    <v-app-bar app color="secondary" short max-height="64px">
      <v-img
        class="hidden-md-and-down mx-2"
        :src="require('@/assets/peterson-logo.png')"
        alt="peterson logo"
        max-height="75"
        max-width="110"
        contain
      ></v-img>

      <v-divider class="mx-2 hidden-md-and-down" vertical inset />

      <v-toolbar-title class="mx-0 mx-lg-2">
        <router-link to="/" style="cursor: pointer" tag="span">
          <span class="nav-font nav-title tertiary--text mr-2">Voyage</span>
          <environment-badge
            v-if="envDisplayText != null && envDisplayText.length > 0"
            :title="envDisplayText"
          />
        </router-link>
        <span v-if="isUserLoggedIn" class="mx-6">
          <span v-if="isClientConnectedToServer">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-icon color="green darken-2">mdi-lan-connect</v-icon>
                </span>
              </template>
              <span>Online - connected to server</span>
            </v-tooltip>
          </span>
          <span v-else>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-icon color="red darken-2">mdi-lan-disconnect</v-icon>
                </span>
              </template>
              <span>Offline - functionality restricted</span>
            </v-tooltip>
          </span>
        </span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <span v-if="isUserLoggedIn">
        <span class="hidden-sm-and-down">
          <v-btn
            small
            v-if="isUser"
            text
            to="/voyage-reports"
            class="text-capitalize"
            active-class="primary--text"
          >
            <v-icon class="mr-2">mdi-ferry</v-icon>
            Voyages
          </v-btn>

          <v-btn
            small
            v-if="isUser && isClientConnectedToServer"
            text
            to="/vessel-overview"
            class="text-capitalize"
            active-class="primary--text"
          >
            <v-icon class="mr-2">mdi-eye</v-icon>
            Overview
          </v-btn>

          <v-btn
            small
            v-if="isUser"
            text
            to="/tanks"
            class="text-capitalize"
            active-class="primary--text"
          >
            <v-icon class="mr-2">mdi-car-coolant-level</v-icon>
            Tanks
          </v-btn>

          <v-menu v-if="isAdmin && isClientConnectedToServer" offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                small
                v-on="on"
                class="text-capitalize"
                active-class="primary--text"
              >
                <v-icon class="mr-2">mdi-file-document-multiple-outline</v-icon
                >Reports
              </v-btn>
            </template>
            <v-list color="primary--text">
              <v-list-item to="/perday-voyage-report">
                <v-list-item-title class="text-capitalize">
                  <v-list-item-icon>
                    <v-icon v-text="'mdi-calendar'"></v-icon>
                  </v-list-item-icon>
                  Daily Voyage Report
                </v-list-item-title>
              </v-list-item>
              <v-list-item to="/perday-tank-status">
                <v-list-item-icon>
                  <v-icon v-text="'mdi-car-coolant-level'"></v-icon>
                </v-list-item-icon>
                <v-list-item-title class="text-capitalize">
                  Daily Tank Report
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-menu v-if="(isAdmin || isDataAdmin)  && isClientConnectedToServer" offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                small
                v-on="on"
                class="text-capitalize"
                active-class="primary--text"
              >
                <v-icon class="mr-2">mdi-cog</v-icon>Admin
              </v-btn>
            </template>
            <v-list class="primary--text">
              <v-list-item v-if="isAdmin" to="/useradmin">
                <v-list-item-title class="text-capitalize">
                  <v-list-item-icon>
                    <v-icon>mdi-account-group</v-icon>
                  </v-list-item-icon>
                  User Admin
                </v-list-item-title>
              </v-list-item>
              <v-list-item to="/dataadmin">
                <v-list-item-title class="text-capitalize">
                  <v-list-item-icon>
                    <v-icon>mdi-database</v-icon>
                  </v-list-item-icon>
                  Data Admin
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                small
                v-on="on"
                class="text-capitalize"
                :disabled="!isClientConnectedToServer"
              >
                <v-icon class="mr-2">mdi-account-circle</v-icon>
                {{ username }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="logout">
                <v-list-item-icon>
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="text-capitalize">
                  Logout
                </v-list-item-title>
              </v-list-item>
              <v-list-item to="/account">
                <v-list-item-icon>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="text-capitalize">
                  Account
                </v-list-item-title>
              </v-list-item>
              <v-list-item :href="tAndCUrl" target="_blank">
                <v-list-item-icon>
                  <v-icon>mdi-file</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="text-capitalize">
                  Terms & Conditions
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </span>

        <v-app-bar-nav-icon
          class="hidden-md-and-up"
          @click.stop="drawer = !drawer"
        ></v-app-bar-nav-icon>
      </span>
    </v-app-bar>
    <!-- Start of mobile side menu -->
    <v-navigation-drawer
      v-if="isUserLoggedIn"
      class="hidden-md-and-up"
      v-model="drawer"
      right
      app
      width="275"
      disable-resize-watcher
    >
      <v-list-item>
        <v-list-item-content>
          <v-img
            :src="require('@/assets/peterson-logo.png')"
            alt="peterson logo"
          />
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <span class="nav-font nav-title primary--text mb-2"
            >Voyage
            <environment-badge
              v-if="envDisplayText != null && envDisplayText.length > 0"
              :title="envDisplayText"
            />
          </span>
          <v-list-item-subtitle>Voyage Reporting Tool</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <v-list-group :disabled="!isClientConnectedToServer">
        <template v-slot:activator>
          <v-list-item class="px-0 text-start" color="primary">
            <v-list-item-avatar>
              <v-icon large>mdi-account-circle</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ username }}</v-list-item-title>
              <v-list-item-subtitle class="caption">{{
                userEmail
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list dense nav shaped>
          <v-list-item @click="logout()" color="primary">
            <v-list-item-title>Logout</v-list-item-title>
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
          </v-list-item>

          <v-list-item to="/account" color="primary">
            <v-list-item-title>Account</v-list-item-title>
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
          </v-list-item>

          <v-list-item color="primary" :href="tAndCUrl" target="_blank">
            <v-list-item-title> Terms & Conditions </v-list-item-title>
            <v-list-item-icon>
              <v-icon>mdi-file</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list>

        <!-- Logout  -->
      </v-list-group>

      <v-divider />

      <v-list dense nav shaped>
        <!-- Nav Routes -->
        <v-list-item
          v-for="item in navItems"
          :key="item.title"
          :to="item.link"
          @click="item.onClick ? item.onClick : null"
          link
          color="primary"
          :disabled="!isClientConnectedToServer && item.disableWhileOffline"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>

        <!-- Admin Group -->
        <div v-if="isAdmin" class="mt-4">
          <v-divider></v-divider>
          <v-list-group
            prepend-icon="mdi-account-cog"
            :value="false"
            :disabled="!isClientConnectedToServer"
          >
            <template v-slot:activator>
              <v-list-item-title>Admin</v-list-item-title>
            </template>
            <v-list-item
              v-for="item in adminNavItems"
              :key="item.title"
              :to="item.link"
              @click="item.onClick ? item.onClick : null"
              link
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list-group>
        </div>
      </v-list>
    </v-navigation-drawer>
  </span>
</template>


<script>

import { mapState, mapGetters } from 'vuex';
import EnvironmentBadge from './EnvironmentBadge.vue';

export default {
  name: 'Navbar',
  components: { EnvironmentBadge },
  data() {
    return {
      showNav: false,
      count: 0,
      setOffline: false,
      iconColor: '#4d4d4d',
      drawer: false, // Hide mobile side menu by default
      tAndCUrl: 'https://elogisticsdocs.blob.core.windows.net/documents/Terms_and_Conditions_of_Use.htm',
      navItems: [
        {
          title: 'Home', icon: 'mdi-home', link: '/', admin: false, disableWhileOffline: false,
        },
        {
          title: 'Voyages', icon: 'mdi-ferry', link: '/voyage-reports', admin: false, disableWhileOffline: false,
        },
        {
          title: 'Overview', icon: 'mdi-eye', link: '/vessel-overview', admin: false, disableWhileOffline: true,
        },
        {
          title: 'Tanks', icon: 'mdi-car-coolant-level', link: '/tanks', admin: false, disableWhileOffline: false,
        },
        {
          title: 'Daily Voyage Report', icon: 'mdi-calendar', link: '/perday-voyage-report', admin: false, disableWhileOffline: true,
        },
        {
          title: 'Daily Tank Report', icon: 'mdi-car-coolant-level', link: '/perday-tank-status', admin: false, disableWhileOffline: true,
        },
      ],
      adminNavItems: [
        {
          title: 'User Admin', icon: 'mdi-account-group', link: '/useradmin', admin: true,
        },
        {
          title: 'Data Admin', icon: 'mdi-database', link: '/dataadmin', admin: true,
        },
      ],
    };
  },
  computed: {
    ...mapState(['userStore', 'voyageReportsStore', 'dataSyncStore']),
    ...mapGetters({
      isUserLoggedIn: 'userStore/isUserLoggedIn',
      isUser: 'userStore/isUser',
      isAdmin: 'userStore/isAdmin',
      isDataAdmin: 'userStore/isDataAdmin',
      isClientConnectedToServer: 'userStore/isClientConnectedToServer',
      getActiveSite: 'userStore/getActiveSite',
      getActiveSiteId: 'userStore/getActiveSiteId',
    }),
    username() {
      return this.userStore.user.username.split('@')[0];
    },
    userEmail() {
      return this.userStore.user.userEmail;
    },
    envDisplayText() {
      return this.userStore.navBarEnvironmentDisplayText;
    },
    isScreenBreakpointLargeAndUp() {
      return this.$vuetify.breakpoint.lgAndUp;
    },
  },
  methods: {
    logout() {
      this.showNav = false;
      this.$store.dispatch('userStore/logout');
    },
    onConnectionStatus({ connected }) {
      this.$store.dispatch('userStore/setIsClientConnectedToServer', connected);
      if (connected) {
        console.log('Reconnected to server - Running data sync.');
        this.$store.dispatch('dataSyncStore/doDataSyncAndReloadVoyageReports', this.getActiveSiteId);
      }
    },
  },
  watch: {
    'userStore.user': function handleLogout(newValue, oldValue) {
      if (!newValue) {
        this.$router.replace('/'); // Switch to login(home) page on logout.
      }
    },
    isScreenBreakpointLargeAndUp(newVal) {
      if (newVal) {
        this.drawer = false;
      }
    },
  },
  created() {
    this.$store.dispatch('userStore/getNavbarEnvDisplayText');
    // Listen to connection changes coming from SignalR events.
    this.$signalrEventBus.$on('connection-status', this.onConnectionStatus);
  },
};
</script>

<style scoped>
</style>
